import {
  type ImgHTMLAttributes,
  type RefObject,
  useRef,
  useState,
} from "react";
import { useIntersection } from "react-use";
import { Image } from "./Image";

type Props = ImgHTMLAttributes<HTMLImageElement> & {
  sentryElementClassName?: string;
};

export const LazyImage = ({ sentryElementClassName, ...props }: Props) => {
  const ref = useRef<HTMLSpanElement>(null);

  // https://github.com/streamich/react-use/issues/2612
  const intersection = useIntersection(ref as RefObject<HTMLSpanElement>, {
    rootMargin: "100px 0px 80% 0px",
  });
  const isIntersecting = intersection?.isIntersecting || false;
  const [shouldLoad, setShouldLoad] = useState<boolean>(isIntersecting);

  if (!shouldLoad && isIntersecting) {
    setShouldLoad(true);
  }

  return (
    <>
      <span ref={ref} className={sentryElementClassName} />
      {shouldLoad ? <Image {...props} /> : null}
    </>
  );
};
